import { Headset } from 'lucide-react';
import { useLocales } from '@/locales';

export default function HandoffBanner() {
  const { translate } = useLocales();
  return (
    <div className="flex items-center gap-2 border-b border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900">
      <Headset className="h-4 w-4 shrink-0" />
      <span>{translate('chat_handoff_banner')}</span>
    </div>
  );
}
